// The share button opens X with the post already written.
//
// His words are the whole point of sharing, so the reaction gets whatever
// room is left after the fixed parts rather than a fixed truncation, and
// it only ever cuts on a word boundary. Pure function, lives here so the
// truncation maths can be tested away from the drawer.
const SHARE_TAIL = 'Check out pinos.world from @3eyes_iii'
const X_LIMIT = 280

export function shareIntent(s, kept) {
  const gift = s.imageUrl ? 'a picture' : 'a message'
  const took = kept ? 'he liked it' : "he didn't like it"
  const head = `I sent Pino ${gift} and ${took}.`
  const said = String(s.reaction || '').trim()

  let text = said ? `${head} He said "${said}" ${SHARE_TAIL}` : `${head} ${SHARE_TAIL}`
  if (text.length > X_LIMIT && said) {
    const room = X_LIMIT - `${head} He said "…" ${SHARE_TAIL}`.length
    let cut = said.slice(0, Math.max(0, room))
    const lastSpace = cut.lastIndexOf(' ')
    if (lastSpace > 20) cut = cut.slice(0, lastSpace)
    text = `${head} He said "${cut}…" ${SHARE_TAIL}`
  }
  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`
}

// A thread, shared: his line under what somebody left him, and the door
// to join. Same room-for-his-words rule as the verdict share.
export function shareThreadIntent(t) {
  const id = String(t?.id || '')
  const owner = String(t?.handle || 'someone').trim() || 'someone'
  const door = `pinos.world/talk/${id}`
  const said = String(t?.lastByHim && t?.lastLine ? t.lastLine : t?.pinoLine || '').trim()
  const head = said ? `Pino said` : `People are talking with Pino about what ${owner} left him.`
  const tail = `Join in: ${door} @3eyes_iii`
  let text = said ? `${head} "${said}" under what ${owner} left him. ${tail}` : `${head} ${tail}`
  if (text.length > X_LIMIT && said) {
    const room = X_LIMIT - `${head} "…" under what ${owner} left him. ${tail}`.length
    let cut = said.slice(0, Math.max(0, room))
    const lastSpace = cut.lastIndexOf(' ')
    if (lastSpace > 20) cut = cut.slice(0, lastSpace)
    text = `${head} "${cut}…" under what ${owner} left him. ${tail}`
  }
  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`
}
